import script from "./ParentAbsences.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentAbsences.vue?vue&type=script&setup=true&lang=js"

import "./ParentAbsences.vue?vue&type=style&index=0&id=f136d904&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f136d904"]])

export default __exports__